import { render, staticRenderFns } from "./ChatNoteV2026.vue?vue&type=template&id=65836373&scoped=true"
import script from "./ChatNoteV2026.vue?vue&type=script&lang=js"
export * from "./ChatNoteV2026.vue?vue&type=script&lang=js"
import style0 from "./ChatNoteV2026.vue?vue&type=style&index=0&id=65836373&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65836373",
  null
  
)

export default component.exports